import styled from "styled-components";

export const ModalMarkPaidContents = styled.div`
	padding: 0 1em;
`;
